import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import useAuth from "hooks/useAuthentication";
import { Menu } from "components/common/Menu";
import { useMediaQuery } from "@mui/material";
import theme from "lib/theme";
import TokenService from "services/token.service";
import MenuIcon from "@mui/icons-material/Menu";
import { useTheme } from 'contexts/ThemeContext';
import { Link } from 'react-router-dom';
import { getOrganizationType } from 'lib/organizationType';

interface NavProps {
  open: boolean;
  handleToggle(): void;
}

export const navActions = {};

function Nav({ open, handleToggle }: NavProps) {
  const isTabletView = useMediaQuery(theme.breakpoints.down('lg'));
  const { loggedIn } = useAuth();
  const { theme: customerTheme } = useTheme();
  const homeHref =
    loggedIn && getOrganizationType() === 'assettech'
      ? '/dashboard'
      : '/pickups';

  return (
    <Box sx={{ flexGrow: 1, position: 'sticky', top: 0, zIndex: 10 }}>
      <AppBar
        variant='outlined'
        elevation={0}
        sx={{
          bgcolor: customerTheme.customer.headerBackgroundColor || 'white',
          color: customerTheme.customer.headerColor || '#000',
          borderColor: customerTheme.customer.headerBackgroundColor || undefined,
        }}
      >
        <Toolbar>
          {isTabletView && loggedIn && (
            <IconButton
              color='primary'
              onClick={handleToggle}
              aria-label={open ? 'Collapse Sidebar' : 'Expand Sidebar'}
            >
              <MenuIcon />
            </IconButton>
          )}

          {/* Logo in top left */}
          {customerTheme.customer.logo &&
            (loggedIn ? (
              <Box
                component={Link}
                to={homeHref}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mr: 2,
                  textDecoration: 'none',
                  color: 'inherit',
                }}
              >
                <img
                  src={customerTheme.customer.logo}
                  alt='Company Logo'
                  style={{
                    height: customerTheme.customer.headerBackgroundColor ? '44px' : '40px',
                    width: 'auto',
                    maxWidth: customerTheme.customer.headerBackgroundColor ? '200px' : '120px',
                    objectFit: 'contain',
                  }}
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.style.display = 'none';
                  }}
                />
              </Box>
            ) : (
              <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
                <img
                  src={customerTheme.customer.logo}
                  alt='Company Logo'
                  style={{
                    height: customerTheme.customer.headerBackgroundColor ? '44px' : '40px',
                    width: 'auto',
                    maxWidth: customerTheme.customer.headerBackgroundColor ? '200px' : '120px',
                    objectFit: 'contain',
                  }}
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.style.display = 'none';
                  }}
                />
              </Box>
            ))}

          <Typography
            variant='h6'
            noWrap
            component='div'
            sx={{ display: 'flex', alignItems: 'center' }}
          ></Typography>
          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
            {/* Remove the old hardcoded logo logic */}
          </Box>
          {loggedIn && (
            <Box sx={{ display: 'flex', alignItems: 'end' }}>
              <Menu
                button={(props) => (
                  <IconButton
                    aria-label='Profile'
                    size='large'
                    color='primary'
                    {...props}
                    sx={
                      customerTheme.customer.headerColor
                        ? { color: customerTheme.customer.headerColor }
                        : undefined
                    }
                  >
                    <AccountCircleIcon />
                  </IconButton>
                )}
                actions={[
                  {
                    label: 'Log Out',
                    onClick: () => {
                      TokenService.remove();
                      window.location.href = '/login';
                    },
                  },
                ]}
              ></Menu>
            </Box>
          )}
        </Toolbar>
        {customerTheme.customer.headerBackgroundColor && (
          <Box
            className="roctelecom-accent-bar"
            sx={{
              height: '3px',
              width: '100%',
              background: `linear-gradient(90deg, ${customerTheme.customer.primaryColor} 0%, ${customerTheme.customer.secondaryColor} 100%)`,
            }}
          />
        )}
      </AppBar>
    </Box>
  );
}

export default Nav;
